<template>
  <div>
    <clip-loader
      :loading="loading"
      :color="loadingColor"
      size="20px"
    ></clip-loader>
    <template v-if="!loading && drugData">

      <div v-if="drugData?.combined_drugs && drugData.combined_drugs.length" class="combined_drugs">
        <p>Препарат состоит из компонентов</p>
        <p v-for="cd in drugData.combined_drugs" :key="cd.combine_drug_id">{{ cd?.drug?.title }} x
          <strong>{{ cd.rate }}</strong></p>
      </div>

      <p class="site_info_data" v-if="siteDataInfo">Данные на справочной: {{ siteDataInfo.title }} цена <strong>{{
          siteDataInfo.price
        }}</strong>р.
      </p>
      <p>Страна поставки: <strong>{{ drugData.country.name }}</strong></p>
      <div class="max-width-75" v-if="isHasValidDatesToDisplay()">
        <p>
          Сроки годности:
          <span v-for="(d, i) in getSortedValidDates(drugData.valid_dates)"><strong>{{
              printDate(d.expire_date, 'MM.YYYY')
            }}</strong>
            <span v-if="d.comment" class="badge badge-dark">{{ d.comment }}</span>{{
              (i + 1) < drugData.valid_dates.length ? ', ' : null
            }}</span>
        </p>
      </div>
      <template v-if="storeData">
        <StoreDataForOrder :updatedStoreData="updatedStoreData"
                           :storeData="storeData"
                           :locality="locality"
                           :inRunnersStores="inRunnersStores"
                           :drug="drug"/>
        <!--        <div class="store_blocks">-->
        <!--          <div-->
        <!--            v-html="getStoreInfoByStore($AllDivisions[locality.division_id]?.stores[0]?.object_id || null)"-->
        <!--            class="selected_store"/>-->
        <!--          <template-->
        <!--            v-for="(storeId, index) in ($StoreRelations[$AllDivisions[locality.division_id]?.stores[0]?.object_id] || [])">-->
        <!--            <div-->
        <!--              v-if="$AllDivisions[locality.division_id]"-->
        <!--              v-html="getStoreInfoByStore(storeId, index === 0 ? $AllDivisions[locality.division_id]?.stores[0]?.object_id : $StoreRelations[$AllDivisions[locality.division_id]?.stores[0]?.object_id][(index-1)])"/>-->
        <!--          </template>-->
        <!--          <div v-if="+locality.city_id === 1 && Object.keys(inRunnersStores[3]).length" class="extra_store_div">-->
        <!--            <p v-for="(storeData, storeId) in inRunnersStores[3]">{{ storeData.title }}:-->
        <!--              <strong>{{ storeData.qty }}</strong></p>-->
        <!--          </div>-->
        <!--        </div>-->
      </template>
      <p v-if="drugData.order_details && drugData.order_details.length">последняя продажа:
        <strong>{{ printDate(drugData.order_details[0].order.report_date, 'DD.MM.YYYY') }}</strong></p>
      <div class="alert alert-warning mt-1 p-1"
           v-if="drug.is_press_can && divisionsWithAirDelivery[$editNewOrder.division_id]">
        <i class="icon-fa icon-fa-warning"/> Преперат в баллоне под давлением (авиа транспортировка невозможна)
      </div>
      <div v-if="analogs && analogs.length" class="alert alert-info mt-1 mb-1 p-1">
        <div v-bind:class="{limitedView: !showAllAnalogs && analogs.length > 4}">
          <p><strong>Такое же действующее вещество: ({{ analogs.length }})</strong></p>
          <p v-for="analog in analogs"><a href="#" @click.prevent="chooseAnalog(analog)">{{ analog.title }}</a></p>
        </div>
        <p class="pointer text-right" v-if="analogs.length > 4" @click="showAllAnalogs = !showAllAnalogs">
          {{ showAllAnalogs ? 'Свернуть' : 'Развернуть' }}</p>
      </div>
    </template>
    <template v-if="managerComments.length">
      <div v-for="(c,i) in managerComments" v-if="allowToDisplay(c)" :key="i" class="alert alert-info p-1 mb-1">
        <p class="mb-0"><span class="badge badge-info"><i class="icon-fa icon-fa-info"/></span> {{ c.comment }}</p>
      </div>
    </template>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import StoreDataForOrder from "@/components/drugs/StoreDataForOrder.vue";

export default {
  components: {StoreDataForOrder},
  props: ['drug', 'locality', 'updateDrug', 'updateTrigger'],
  data() {
    return {
      loading: false,
      dataLoaded: false,
      loadingColor: this.$constants.LOADING_COLOR,
      drugData: null,
      storeData: null,
      analogs: null,
      updatedStoreData: {},
      actualStoreId: null,
      actualStoreQty: 0,
      selectedCityId: null,
      showAllAnalogs: false,
      siteDataInfo: null,
      managerComments: [],
      divisionsWithAirDelivery: {},
      inRunnersStores: {3: {}},
      siteDataMap: {
        14: 12
      }
    }
  },
  watch: {
    'locality': {
      handler: function (val, oldVal) {
        this.setCurrentActualStore();
      },
      deep: true,
    }
  },
  computed: {
    $StoreRelations() {
      return this.$store.getters['platform/storeRelations']
    },
    $AllCities() {
      return this.$store.getters['platform/cities']
    },
    $AllStores() {
      return this.$store.getters['platform/stores']
    },
    $editNewOrder() {
      return this.$store.getters['orders/editNewOrder']
    },
  },
  created() {
    this.getInfo()
    if (this.$editNewOrder.id) {
      this.selectedCityId = this.$editNewOrder.city_id
    }
    this.setCurrentActualStore();
    this.divisionsWithAirDelivery = ((this.$store.getters["platform/settings"]?.general ?? []).find((r) => r.option === "airDeliveryDivisions")?.sub_value ?? []).reduce((acc, d) => {
      acc[d.id] = d;
      return acc;
    }, {});

  },
  methods: {
    getSortedValidDates(records) {
      return records.filter((d) => d.is_active).sort(function (a, b) {
        return new Date(a.expire_date) - new Date(b.expire_date);
      });
    },
    allowToDisplay(comment) {
      let allow = true;
      if (comment.selected_projects.length && !comment.selected_projects.includes(+this.locality.site_id)) allow = false;
      if (!comment.permanent && moment(comment.valid_date, 'DD.MM.YYYY') < moment()) allow = false;
      return allow;
    },
    isHasValidDatesToDisplay() {
      if ((this.drugData.valid_dates ?? []).find((d) => d.is_active)) return true;
      let arr = [...(this.drugData.valid_dates ?? [])];
      arr.sort((a, b) => {
        let aa = new Date(a.expire_date);
        let bb = new Date(b.expire_date);
        return bb - aa;
      });
      // if (arr.length) {
      //   console.log(arr);
      // }
      return false;
    },
    setCurrentActualStore() {
      this.actualStoreId = this.$AllCities[this.locality.city_id] && this.$AllCities[this.locality.city_id].store && this.$AllCities[this.locality.city_id].store.store_id || null;
      this.actualStoreQty = this.getStoreInfoByStore(this.actualStoreId, null, true);
    },
    chooseAnalog(analog) {
      if (this.updateDrug) {
        this.updateDrug(analog)
        setTimeout(() => {
          this.getInfo();
        }, 100)
      }
    },
    getStoreInfoByStore(storeId, exclude = null, numberOnly = false) {
      // console.log(storeId, exclude, numberOnly);
      if (!storeId) {
        storeId = this.actualStoreId;
      }
      if (!storeId) return;
      if (!this.updatedStoreData?.clearedStore) return;
      const stores = this.getRelatedRequestsByStoreId(storeId, exclude)
      // console.log(storeId, exclude, stores)
      let qty = (this.updatedStoreData.clearedStore[storeId] || 0) - (this.updatedStoreData.storesRequests[storeId] || 0)
      // console.log(stores, qty, storeId, this.updatedStoreData.clearedStore[storeId]);
      stores.forEach((sId) => {
        qty -= +(this.updatedStoreData.storesRequests[sId] || 0)
      })

      let transitQty = 0
      let transitDate = moment()
      if (this.storeData.transitDetails[this.drug.id] && this.storeData.transitDetails[this.drug.id][storeId] && this.storeData.transitDetails[this.drug.id][storeId].details_in) {
        this.storeData.transitDetails[this.drug.id][storeId].details_in.forEach((t) => {
          transitQty += t.qty
          if (transitDate < moment(t.date)) {
            transitDate = moment(t.date)
          }
        })
      }
      let inStore = this.updatedStoreData.inStore && this.updatedStoreData.inStore[storeId] || 0
      inStore -= Object.keys(this.storeData.requests[this.drug.id] && this.storeData.requests[this.drug.id][storeId] || {}).reduce((acc, reserveType) => {
        acc += +this.storeData.requests[this.drug.id][storeId][reserveType].qty
        return acc
      }, 0)
      if (numberOnly) return qty;
      return (this.$AllStores[storeId] && this.$AllStores[storeId].short_title || `Не найден (${storeId})`) + ': <strong>' + (qty) + '</strong>'
        + (transitQty ? ` из них на складе <strong>${inStore}</strong> в дороге <strong>${transitQty}</strong> (поступление ${transitDate.format('DD.MM')})` : '')
    },
    updateSiteDataInfo(data) {
      if (this.siteDataMap[this.$editNewOrder.site_id]) {
        const title = data.site_details.find((d) => d.site_id === +this.siteDataMap[this.$editNewOrder.site_id]);
        const price = data.prices.find((p) => p.site_id === +this.siteDataMap[this.$editNewOrder.site_id] && p.qty === 1);
        if (price && price.rate && price.packing && (price.rate !== 1 && price.packing !== 1)) {
          this.siteDataInfo = {
            title: title.text_value,
            price: price.price * price.rate / price.packing,
          }
        }
      }
    },
    async getInfo() {
      this.loading = true;
      this.siteDataInfo = null;
      const {data} = await api.index('/new/drugs/info/' + this.drug.id)
      if (data.success) {
        const updatedStoreData = {
          inStore: data.storeData.actualStoreData[this.drug.id],
          clearedStore: {},
          storesRequests: {},
          relatedRequests: {},
        }
        Object.keys(data.storeData.transitDetails[this.drug.id] || {}).forEach((storeId) => {
          if (data.storeData.transitDetails[this.drug.id][storeId].out) {
            if (!updatedStoreData.inStore[storeId]) {
              updatedStoreData.inStore[storeId] = 0
            }
            updatedStoreData.inStore[storeId] -= data.storeData.transitDetails[this.drug.id][storeId].out
          }
        })

        Object.keys(this.$AllStores).forEach((sId) => {
          let re = (updatedStoreData.inStore && updatedStoreData.inStore[sId] || 0)
          Object.values(data.storeData.requests[this.drug.id] && data.storeData.requests[this.drug.id][sId] || {}).forEach((rr) => {
            Object.keys(rr.ordersQty).forEach((oId) => {
              if (this.$editNewOrder.id !== +oId) {
                re -= +rr.ordersQty[oId]
                // re -= rr.qty;
              }
            })
          })

          if (data.storeData.transitDetails[this.drug.id] && data.storeData.transitDetails[this.drug.id][sId] && data.storeData.transitDetails[this.drug.id][sId].in) {
            re += data.storeData.transitDetails[this.drug.id][sId].in
          }

          if (re < 0) {
            updatedStoreData.clearedStore[sId] = 0
            updatedStoreData.storesRequests[sId] = Math.abs(re)
          } else {
            updatedStoreData.clearedStore[sId] = re
          }
        })
        this.updatedStoreData = updatedStoreData

        this.storeData = data.storeData
        this.drugData = data.drugData
        this.analogs = data.analogs
        this.managerComments = data.drugData.details.find((d) => d.group_alias === 'managers_info' && d.alias === 'comments')?.array_value ?? [];

        this.updateSiteDataInfo(data.drugData);

        Object.values(this.$AllDivisions).forEach((d) => {
          if (+d.id === 1 || +d.id === 142) return;
          if (d.cities.find((c) => c.object_id === 1)) {
            const storeId = d.stores[0].object_id;
            const inStore = this.storeData?.inStores?.[this.drug.id]?.[storeId] ?? 0;
            if (!this.inRunnersStores[3][storeId]) {
              this.inRunnersStores[3][storeId] = {
                title: d.title,
                qty: 0,
                storeId: storeId
              };
            }
            this.inRunnersStores[3][storeId].qty += inStore > 0 ? inStore : 0;
          }
        })
        // console.log(this.inRunnersStores[3]);
        this.inRunnersStores[3] = Object.values(this.inRunnersStores[3]).reduce((acc, sData) => {
          if (sData.qty > 0) {
            acc[sData.storeId] = sData;
          }
          return acc;
        }, {});

      } else {

      }
      this.setCurrentActualStore();
      this.dataLoaded = true;
      if (this.updateDrug) {
        // console.log(this.drug);
        this.updateDrug({...this.drug});
      }
      if (this.updateTrigger) this.updateTrigger();
      this.loading = false
    },
    getRelatedRequestsByStoreId(storeId, exclude, index = 0, sortedStores = []) {
      const stores = Object.values(this.$AllStores).filter((s) => s.parent_id === +storeId)
      stores.forEach((s) => {
        if (exclude != s.id) {
          sortedStores = this.getRelatedRequestsByStoreId(s.id, exclude, 1, sortedStores)
        }
      })
      if (index) {
        sortedStores.push(storeId)
      }
      return sortedStores
    }
  }
}
</script>

<style scoped>
.store_blocks div.extra_store_div {
  border: 4px solid #5bbfde;
  margin-left: auto;
}

.site_info_data {
  border: 1px solid lightgray;
  padding: 2px;
  margin: 3px 0;
}

.limitedView {
  height: 100px;
  overflow: hidden;
}

.max-width-75 {
  max-width: 75%;
}

.store_blocks {
  display: flex;
  flex-wrap: wrap;
}

.store_blocks .selected_store {
  border: 3px solid gray;
}

.store_blocks div {
  padding: 0 5px;
  border: 2px solid lightgray;
  margin-right: 3px;
}

.clear_span,
.clear_span span {
  border: none !important;
  margin-right: 0 !important;
}

p {
  margin-bottom: 0;
}

.combined_drugs {
  padding: 3px;
  background-color: #f2f2f2;
}

.combined_drugs p {
  margin-bottom: 1px;
}
</style>
